import { applyMark } from '../utils/apply-mark';
export var link = function link(attrs) {
  return function (maybeNode) {
    return applyMark({
      type: 'link',
      attrs: attrs
    }, maybeNode);
  };
};